import {
  IconSparkles,
  IconShieldCheck,
  IconCashBanknote, // Renamed/Corrected
  IconFlame,
  IconCalendar,
  IconCrown,
  IconBolt, // Was IconZap
  IconWalk, // Was IconFootprints (approximation)
  IconCircleCheck,
  IconTrophy,
  IconMedal,
  IconHeadphones,
  IconShare,
  IconCoin,
  IconDiamond,
  IconBuildingBank,
  IconCreditCard,
  IconUserPlus,
  IconUsers,
  IconSpeakerphone,
} from "@tabler/icons-react";
import React from "react";

// Mapping Lucide names (from Backend) to Tabler Icons (used in Admin)
const ICON_MAP: Record<string, any> = {
  Sparkles: IconSparkles,
  ShieldCheck: IconShieldCheck,
  Banknote: IconCashBanknote,
  Flame: IconFlame,
  Calendar: IconCalendar,
  Crown: IconCrown,
  Zap: IconBolt,
  Footprints: IconWalk,
  CheckCircle2: IconCircleCheck,
  Trophy: IconTrophy,
  Medal: IconMedal,
  Headphones: IconHeadphones,
  Share2: IconShare,
  Coins: IconCoin,
  Gem: IconDiamond,
  Landmark: IconBuildingBank,
  CreditCard: IconCreditCard,
  UserPlus: IconUserPlus,
  Users: IconUsers,
  Megaphone: IconSpeakerphone,
};

interface BadgeIconProps {
  name: string;
  size?: number;
  color?: string;
  stroke?: number;
}

export function BadgeIcon({
  name,
  size = 24,
  color = "currentColor",
  stroke = 2,
}: BadgeIconProps) {
  const Icon = ICON_MAP[name] || IconSparkles;
  return <Icon size={size} color={color} stroke={stroke} />;
}
